module.exports = __webpack_public_path__ + "img/feature-2.f1f906d6.jpg";